import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is included
import Footer from '../component/Footer';

const Andrology = () => {
  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">Andrology Urology Care</h1>

        <section className="mb-4">
          <h2>Erectile Dysfunction (ED)</h2>
          <p className="text-justify">
            Erectile dysfunction (ED) is the inability to achieve or maintain an erection sufficient for sexual activity. It can affect men of all ages, though it becomes more common with age. This condition can be caused by physical factors like heart disease, diabetes, low testosterone levels, or psychological factors like stress or anxiety.
          </p>

          <h5>Symptoms:</h5>
          <ul>
            <li>Difficulty achieving or maintaining an erection during sexual activity.</li>
            <li>Reduced sexual desire or interest.</li>
            <li>Strain or frustration due to consistent erectile issues.</li>
          </ul>

          <p className="text-justify">
            If you’re experiencing these symptoms, it’s important to seek medical help early to address the root cause and restore your sexual function.
          </p>
        </section>

        <section className="mb-4">
          <h2>Premature Ejaculation</h2>
          <p className="text-justify">
            Premature ejaculation (PE) is a condition where ejaculation occurs sooner than desired during sexual activity, often before or shortly after penetration. This is the most common sexual dysfunction among men, particularly in younger men. While many cases are psychological, physical factors such as hormonal imbalances or medical conditions may contribute.
          </p>

          <h5>Symptoms:</h5>
          <ul>
            <li>Ejaculation occurs within one to two minutes of penetration.</li>
            <li>Inability to control the timing of ejaculation.</li>
            <li>Persistent anxiety or stress about sexual performance.</li>
          </ul>

          <p className="text-justify">
            With treatment, PE can be managed effectively, improving sexual satisfaction for both partners.
          </p>
        </section>

        <section className="mb-4">
          <h2>Prostatitis</h2>
          <p className="text-justify">
            Prostatitis is inflammation of the prostate gland, which can cause pain and discomfort in the pelvic area and urinary difficulties. It can be caused by bacterial infections or non-infectious factors such as pelvic muscle tension. Prostatitis can be acute (sudden onset) or chronic (long-lasting), and it can affect men of all ages, though it is most common in men aged 35 to 55.
          </p>

          <h5>Symptoms:</h5>
          <ul>
            <li>Pain or discomfort in the lower abdomen, perineum (between scrotum and anus), or lower back.</li>
            <li>Painful urination or burning sensation while urinating.</li>
            <li>Increased frequency of urination, especially at night (nocturia).</li>
            <li>Painful ejaculation or discomfort during sex.</li>
            <li>Difficulty starting or stopping urine flow.</li>
          </ul>

          <p className="text-justify">
            Prostatitis is treatable, but it’s important to seek medical advice early for effective management.
          </p>
        </section>
      </div>

      <Footer/>
    </>
  );
}

export default Andrology;
